import Vue from 'vue'
import axios from 'axios'

// axios

// Base URL comes from env so cutover between the legacy service (:3338) and
// Agent-Main-Service (:3402) is a config change, not a code change.
const baseURL = `${process.env.VUE_APP_API_ENDPOINT ||
  'http://0.0.0.0:3402'}/api/v1`

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

// Internal API key — required by Agent-AMB-Service for /internal/* routes
axiosIns.defaults.headers.common['x-internal-key'] =
  process.env.VUE_APP_INTERNAL_API_KEY

axiosIns.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status
    const url = err.config?.url

    switch (status) {
      case 401:
        // Skip for login endpoint - let component handle invalid credentials
        if (url?.includes('/auth/member/login')) {
          break
        }
        // For other endpoints (token expired), clear auth and redirect
        localStorage.removeItem('accessToken')
        localStorage.removeItem('userData')
        window.location.href = '/'
        break
      default:
        break
    }
    // CRITICAL: Re-throw the error so it can be caught by component code
    return Promise.reject(err)
  }
)

// // Request Interceptor
// this.axiosIns.interceptors.request.use(
//   config => {
//     // Get token from localStorage
//     const accessToken = jwt.getToken()

//     // If token is present add it to request's Authorization Header
//     if (accessToken) {
//       // eslint-disable-next-line no-param-reassign
//       config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
//     }
//     return config
//   },
//   error => Promise.reject(error)
// )
export function setRequestHeader(key, value) {
  axiosIns.defaults.headers.common[key] = value
}

Vue.prototype.$http = axiosIns

export default axiosIns
